import { render, staticRenderFns } from "./SentimentsAmdIndia.vue?vue&type=template&id=beeb4286&scoped=true"
import script from "./SentimentsAmdIndia.vue?vue&type=script&lang=js"
export * from "./SentimentsAmdIndia.vue?vue&type=script&lang=js"
import style0 from "./SentimentsAmdIndia.vue?vue&type=style&index=0&id=beeb4286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beeb4286",
  null
  
)

export default component.exports